import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { HttpModule, BaseRequestOptions, RequestOptions, RequestOptionsArgs } from '@angular/http';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app.routing.module';
import { WelcomeComponent } from './welcome/welcome.component';
import { LoginComponent } from './headerandnavigation/login/login.comonent';
import { ContactComponent } from './headerandnavigation/contact/contact.component';
import { LoggedUserComponent } from './headerandnavigation/loggeduser/loggeduser.component';
import { AccountsComponent } from './headerandnavigation/accounts/accounts.component';
import { SideNavigation } from './headerandnavigation/sidenavigation/sidenavigation.component';
import { ForgottenPasswordComponent } from './headerandnavigation/forgottenpassword/forgottenpassword.component';
import { PageNotFoundComponent } from './pagenotfound/page-not-found.component';


/* Feature Modules */
import { SharedModule} from './shared/shared.module';
import { ManageCardsModule } from './managecards/managecards.module';
import { HomeModule } from './home/home.module';
import { UsersModule } from './users/users.module';
import { ReportsModule } from './reports/reports.module';
import { InvoicingModule } from './invoicing/invoicing.module';
import { PumpLocatorModule } from './pumplocator/pumplocator.module';
import { CardTransactionModule } from './cardtransaction/cardtransaction.module';
import { GenericModule } from './genericpages/generic.module';
import { FooterComponent } from './headerandnavigation/footer/footer.component';
import { LoginPageComponent } from './headerandnavigation/login/loginpage.component';
import { ResetPasswordComponent } from './headerandnavigation/resetpassword/resetpassword.component';
import { BlogsModule } from './blogs/blogs.module';
import { ImpersonateLoginComponent } from './headerandnavigation/login/impersonatelogin.component';
import { RegisterComponent } from './headerandnavigation/register/register.component';
import { RegisterConfirmationComponent } from './headerandnavigation/register/registerconfirmation.component';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { DatePipe } from '@angular/common';
import { ServicesPreloginComponent } from './headerandnavigation/services/servicesprelogin.component';
import { ServicesPostloginComponent } from './headerandnavigation/services/servicespostlogin.component';

import { AuthModule, OidcSecurityService, OidcConfigService, OpenIDImplicitFlowConfiguration, AuthWellKnownEndpoints } from 'angular-auth-oidc-client';
import { ConfigurationService } from './configuration/configuration.service';
import { UnauthorizedComponent } from './users/unauthorized.component';
import { ForbiddenComponent } from './users/forbidden.component';
import { IdentityLoginComponent } from './headerandnavigation/login/identitylogin.component';
import { IdentityLogoutComponent } from './headerandnavigation/login/identitylogout.component';
import { AuthService } from './auth.service';
import{LogoutComponent} from './Logout.component';
import { NoAccessComponent } from './users/noaccess.component';
import { HoldingComponent } from './genericpages/holding.component';

const appInitializerFn = (appConfig: ConfigurationService) => {
  return () => {
    return appConfig.loadConfig();
  };
};


export function loadConfig(oidcConfigService: OidcConfigService) {
    console.log('APP_INITIALIZER STARTING');
    
  return () => oidcConfigService.load('/assets/auth.clientConfiguration.json');
}

@NgModule({
  declarations: [
    AppComponent,    
    WelcomeComponent,    
    PageNotFoundComponent,
    LoginComponent,
    //LogoutComponent,
    ServicesPreloginComponent,
    ServicesPostloginComponent,
    ContactComponent,
    LoggedUserComponent,
    AccountsComponent,
    SideNavigation,
    ForgottenPasswordComponent,
    LoginPageComponent,
    ResetPasswordComponent,
    ImpersonateLoginComponent,
    RegisterComponent,
    RegisterConfirmationComponent,
    UnauthorizedComponent,
    ForbiddenComponent,
    IdentityLoginComponent,
    IdentityLogoutComponent,
    LogoutComponent,
    NoAccessComponent,
    HoldingComponent
  ],
  imports: [
    BrowserModule,
    HttpModule,
    HttpClientModule,
    GenericModule,
    HomeModule,
    ManageCardsModule,
    UsersModule,
    BlogsModule,
    ReportsModule,
    InvoicingModule,
    PumpLocatorModule,
    CardTransactionModule,
    SharedModule,
    AppRoutingModule,
    AuthModule.forRoot(),
    
  ],
  providers: [    
    OidcConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: loadConfig,
      deps: [OidcConfigService],
      multi: true,
    },
    DatePipe
  ] ,
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(
    private oidcSecurityService: OidcSecurityService,
    private oidcConfigService: OidcConfigService,
    public authService: AuthService
  ) {
    this.oidcConfigService.onConfigurationLoaded.subscribe(() => {      
      this.authService.clientId = oidcConfigService.clientConfiguration.client_id;

      const openIDImplicitFlowConfiguration = new OpenIDImplicitFlowConfiguration();
      openIDImplicitFlowConfiguration.stsServer = this.oidcConfigService.clientConfiguration.stsServer;
      openIDImplicitFlowConfiguration.redirect_url = this.oidcConfigService.clientConfiguration.redirect_url;
      // The Client MUST validate that the aud (audience) Claim contains its client_id value registered at the Issuer
      // identified by the iss (issuer) Claim as an audience.
      // The ID Token MUST be rejected if the ID Token does not list the Client as a valid audience,
      // or if it contains additional audiences not trusted by the Client.
      openIDImplicitFlowConfiguration.client_id = this.oidcConfigService.clientConfiguration.client_id;
      openIDImplicitFlowConfiguration.response_type = this.oidcConfigService.clientConfiguration.response_type;
      openIDImplicitFlowConfiguration.scope = this.oidcConfigService.clientConfiguration.scope;
      openIDImplicitFlowConfiguration.post_logout_redirect_uri = this.oidcConfigService.clientConfiguration.post_logout_redirect_uri;
      openIDImplicitFlowConfiguration.start_checksession = this.oidcConfigService.clientConfiguration.start_checksession;
      openIDImplicitFlowConfiguration.silent_renew = this.oidcConfigService.clientConfiguration.silent_renew;
      openIDImplicitFlowConfiguration.silent_renew_offset_in_seconds = this.oidcConfigService.clientConfiguration.silent_renew_offset_in_seconds;
      openIDImplicitFlowConfiguration.silent_renew_url = this.oidcConfigService.clientConfiguration.silent_renew_url;
      //openIDImplicitFlowConfiguration.post_login_route = this.oidcConfigService.clientConfiguration.startup_route;
      //// HTTP 403
      //openIDImplicitFlowConfiguration.forbidden_route = this.oidcConfigService.clientConfiguration.forbidden_route;
      //// HTTP 401
      //openIDImplicitFlowConfiguration.unauthorized_route = this.oidcConfigService.clientConfiguration.unauthorized_route;
      //openIDImplicitFlowConfiguration.log_console_warning_active = this.oidcConfigService.clientConfiguration.log_console_warning_active;
      //openIDImplicitFlowConfiguration.log_console_debug_active = this.oidcConfigService.clientConfiguration.log_console_debug_active;
      // id_token C8: The iat Claim can be used to reject tokens that were issued too far away from the current time,
      // limiting the amount of time that nonces need to be stored to prevent attacks.The acceptable range is Client specific.
        openIDImplicitFlowConfiguration.max_id_token_iat_offset_allowed_in_seconds = this.oidcConfigService.clientConfiguration.max_id_token_iat_offset_allowed_in_seconds;
        openIDImplicitFlowConfiguration.disableIatOffsetValidation = this.oidcConfigService.clientConfiguration.disableIatOffsetValidation;
        //
      const authWellKnownEndpoints = new AuthWellKnownEndpoints();
      authWellKnownEndpoints.setWellKnownEndpoints(this.oidcConfigService.wellKnownEndpoints);

      this.oidcSecurityService.setupModule(
        openIDImplicitFlowConfiguration,
        authWellKnownEndpoints
      );
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts